import { Component, MouseEvent } from 'react';

export type ConfirmDeleteChildrenProps = {
  onClick: (e?: MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
  confirm: boolean;
};

type ConfirmDeleteProps = {
  onClick: ConfirmDeleteChildrenProps['onClick'];
  children: (args: ConfirmDeleteChildrenProps) => React.ReactNode;
};

type ConfirmDeleteState = {
  confirm: ConfirmDeleteChildrenProps['confirm'];
};

export class ConfirmDelete extends Component<
  ConfirmDeleteProps,
  ConfirmDeleteState
> {
  state = { confirm: false };
  private timer?: ReturnType<typeof setTimeout>;

  setConfirm = (confirm: boolean) => this.setState({ confirm });

  click = (e?: MouseEvent<HTMLButtonElement>) => {
    if (this.state.confirm) {
      this.props.onClick(e);
      this.cancel();
    } else {
      this.setConfirm(true);
      this.startAutoCancelTimer();
    }
  };

  cancel = () => {
    this.setConfirm(false);
    this.clearAutoCancelTimer();
  };

  componentWillUnmount() {
    this.clearAutoCancelTimer();
  }

  render() {
    const { children } = this.props;
    const { confirm } = this.state;

    return children({
      onClick: this.click,
      onCancel: this.cancel,
      confirm
    });
  }

  private startAutoCancelTimer() {
    this.clearAutoCancelTimer();
    this.timer = setTimeout(() => this.cancel(), 4000);
  }

  private clearAutoCancelTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}
